// Shared date formatting — every page used to define its own local
// formatDate() with the locale hardcoded to 'tr-TR', so month names
// (and other locale-sensitive parts) rendered in Turkish regardless of
// the UI language the user actually had selected (English/Spanish
// included). Centralized here so switching the UI language actually
// changes how dates look everywhere, not just the static label text.
export type AppLanguage = 'en' | 'tr' | 'es';

const LOCALE_BY_LANGUAGE: Record<AppLanguage, string> = {
  en: 'en-US',
  tr: 'tr-TR',
  es: 'es-ES'
};

export function resolveLocale(language: string): string {
  return LOCALE_BY_LANGUAGE[language as AppLanguage] || LOCALE_BY_LANGUAGE.en;
}

const DEFAULT_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};

export function formatDateTime(
  dateStr: string | null | undefined,
  language: string,
  options: Intl.DateTimeFormatOptions = DEFAULT_OPTIONS
): string {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString(resolveLocale(language), options);
  } catch {
    return '-';
  }
}
